import React from "react";
import { Route, Switch } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from "../../../custom-axios";
import { ApiConstants } from "../../../utils/api-constants";
import { AppUtils } from "../../../utils/app-utils";
import Checkout from "./checkout/checkout";
import NewCardPayment from "./checkout/new-card-payment";
import PaymentCompleteComponent from "./checkout/payment-complete";
import PaymentSettings from "./payment-settings/payment-settings";
import Policy from "./policy/policy";
import {
  saveCustomerProfile,
} from "../../../redux/reducers/customer-profile-reducer";
import {
  clearCartData,
} from "../../../redux/reducers/membership-purchase-reducer";
import { PageHeader } from "../../../UI-Component-Library";
import { PetplaceLogo } from "../../../utils/svg-icons";
const queryString = require("query-string");

class PetplaceContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      animalId: null,
    }
  }
  getCustomerProfile = () => {
    axios
      .processGet(
        `${ApiConstants.URL_CUSTOMER_PROFILE}${AppUtils.getToken()}`,
        this.cRef
      )
      .then((response) => {
        this.props.saveCustomerProfile(response);
      })
      .catch(() => {});
  };

  componentDidMount() {
    const parsed = queryString.parse(this.props.history.location.search);
    if( parsed ) {
      this.setState({
        animalId: parsed.animalID,
      })
    }

    this.getCustomerProfile();
  }
  render() {
    return (
      <React.Fragment>
        <PageHeader
          showMobileMenu={false}
          showAccount= {false}
          logo={<PetplaceLogo />}
          showReportLostPetButton={false}
          reportLostPetButtonProps={{
            id: "auth_report_lost_found_button",
            onClick: () => {},
          }}
          accountMenuProps={{
            id: "account_button",
            items: [],
            showNotificationMark: false,
            closeMenu: () => {}
          }}
          showPetProPortalButton={false}
          petProPortalButtonProps={{
            onClick: () => {}
          }}
          onLogoClick={(e) => {
            this.props.clearCartData();
            window.location.replace(`${AppUtils.getPetPlaceBaseUrl()}/account/my-pets/${this.state.animalId}`)
            e.preventDefault();
          }}
        ></PageHeader>
        <Switch>
          <Route path="/petplace/cart" component={Checkout}></Route>
          <Route
            path="/petplace/payment/success"
            component={PaymentCompleteComponent}
          ></Route>
          <Route path="/petplace/payment" component={NewCardPayment}></Route>
          <Route path="/petplace/payment-setting" component={PaymentSettings}></Route>
          <Route path="/petplace/policy" component={Policy}></Route>
        </Switch>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const membershipPurchaseStore = state.membershipPurchaseStore;
  const customerProfileStore = state.customerProfileStore;

  return {
    customerAnimals: customerProfileStore.customerAnimals,
    cartData: membershipPurchaseStore.cartData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    saveCustomerProfile: (data) => dispatch(saveCustomerProfile(data)),
    clearCartData: () => dispatch(clearCartData()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PetplaceContainer));